module.exports = __webpack_public_path__ + "assets/img/vip2.8fda1544.jpg";